(() => {
  document.documentElement.classList.remove('no-js');

  const money = (cents) => new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON', maximumFractionDigits: 0 }).format(cents / 100);
  const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.addEventListener('click', (event) => {
    document.querySelectorAll('.site-header details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.removeAttribute('open');
    });
  });

  document.querySelectorAll('[data-filter-form] input').forEach((input) => {
    input.addEventListener('change', () => input.form.submit());
  });
  document.querySelectorAll('form.collection-sort').forEach((sortForm) => {
    const params = new URLSearchParams(window.location.search);
    sortForm.querySelectorAll('input[name^="filter."]').forEach((input) => {
      input.value = params.get(input.name) || input.value;
    });
  });
  const filtersPanel = document.querySelector('.filters');
  const filtersBackdrop = document.querySelector('.filters-backdrop');
  const filterControls = Array.from(document.querySelectorAll('[data-mobile-filter]'));
  const setFiltersOpen = (open) => {
    if (!filtersPanel) return;
    filtersPanel.classList.toggle('is-open', open);
    filtersPanel.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('is-filter-open', open);
    document.querySelector('[data-filter-trigger]')?.setAttribute('aria-expanded', open ? 'true' : 'false');
    ['opacity', 'visibility', 'pointer-events', 'transform'].forEach((property) => filtersPanel.style.removeProperty(property));
    if (open) {
      filtersPanel.style.setProperty('opacity', '1', 'important');
      filtersPanel.style.setProperty('visibility', 'visible', 'important');
      filtersPanel.style.setProperty('pointer-events', 'auto', 'important');
      filtersPanel.style.setProperty('transform', window.matchMedia('(max-width: 989px)').matches ? 'translate(-50%, -50%)' : 'translateY(0) scale(1)', 'important');
    }
    const closeButton = filtersPanel.querySelector('.filters__close');
    if (closeButton) {
      closeButton.style.removeProperty('display');
      if (open) closeButton.style.setProperty('display', 'inline-grid', 'important');
    }
    if (filtersBackdrop) {
      ['opacity', 'visibility', 'pointer-events'].forEach((property) => filtersBackdrop.style.removeProperty(property));
      if (open) {
        filtersBackdrop.style.setProperty('opacity', '1', 'important');
        filtersBackdrop.style.setProperty('visibility', 'visible', 'important');
        filtersBackdrop.style.setProperty('pointer-events', 'auto', 'important');
      }
    }
    if (open) window.setTimeout(() => filtersPanel.querySelector('button:not([disabled]),a[href],input:not([disabled])')?.focus(), 0);
    else document.querySelector('[data-filter-trigger]')?.focus();
  };
  filterControls.forEach((button) => {
    button.addEventListener('click', () => setFiltersOpen(!filtersPanel?.classList.contains('is-open')));
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && filtersPanel?.classList.contains('is-open')) setFiltersOpen(false);
    if (event.key !== 'Tab' || !filtersPanel?.classList.contains('is-open')) return;
    const focusable = Array.from(filtersPanel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled])'));
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });

  document.querySelectorAll('[data-product-root]').forEach((productRoot) => {
    const json = productRoot.querySelector('[data-variants-json]');
    if (!json) return;
    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }
    const form = productRoot.querySelector('[data-product-form]');
    const idInput = form?.querySelector('[name="id"]');
    const priceEl = productRoot.querySelector('[data-product-price]');
    const submit = form?.querySelector('[type="submit"]');
    const optionInputs = Array.from(productRoot.querySelectorAll('[data-option-input]'));

    const updateVariant = () => {
      const groups = Array.from(productRoot.querySelectorAll('[data-option-group]'));
      const selected = groups.map((group) => group.querySelector('[data-option-input]:checked')?.value);
      const variant = variants.find((item) => item.options.every((value, index) => value === selected[index]));
      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = 'Combinație indisponibilă'; }
        return;
      }
      if (idInput) idInput.value = variant.id;
      if (priceEl) {
        priceEl.innerHTML = money(variant.price) + (variant.compare_at_price && variant.compare_at_price > variant.price ? ' <s>' + money(variant.compare_at_price) + '</s>' : '');
      }
      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Adaugă în coș' : 'Indisponibil momentan';
      }
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));
    updateVariant();

    form?.querySelectorAll('[data-addon-id]').forEach((input) => {
      input.addEventListener('change', () => input.closest('.addon')?.classList.toggle('is-selected', input.checked));
    });

    form?.addEventListener('submit', async (event) => {
      const addons = Array.from(form.querySelectorAll('[data-addon-id]:checked'));
      if (!addons.length) return;
      event.preventDefault();
      if (!form.reportValidity()) return;
      if (submit) { submit.disabled = true; submit.textContent = 'Se adaugă…'; }
      const data = new FormData(form);
      const properties = {};
      data.forEach((value, key) => {
        const found = key.match(/^properties\[(.+)\]$/);
        if (found && value) properties[found[1]] = value;
      });
      const items = [{ id: Number(data.get('id')), quantity: Number(data.get('quantity') || 1), properties: properties }];
      addons.forEach((addon) => items.push({ id: Number(addon.dataset.addonId), quantity: 1, properties: { 'Cadou pentru': productRoot.dataset.productTitle } }));
      try {
        const response = await fetch(rootUrl + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) throw new Error('add failed');
        window.location.href = rootUrl + 'cart';
      } catch (error) {
        if (submit) { submit.disabled = false; submit.textContent = 'Adaugă în coș'; }
      }
    });
  });

  document.querySelectorAll('[data-delivery-date]').forEach((input) => {
    const today = new Date();
    if (today.getHours() >= 20) today.setDate(today.getDate() + 1);
    const localDate = new Date(today.getTime() - today.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
    input.min = localDate;
    if (!input.value) input.value = localDate;
  });

  document.querySelectorAll('[data-quantity]').forEach((quantity) => {
    const input = quantity.querySelector('input');
    quantity.querySelector('[data-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 0), Number(input.value) - 1);
      input.form?.submit();
    });
    quantity.querySelector('[data-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value) + 1;
      input.form?.submit();
    });
  });

  document.querySelectorAll('[data-cart-remove]').forEach((link) => {
    link.addEventListener('click', async (event) => {
      event.preventDefault();
      try {
        const response = await fetch(rootUrl + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: link.dataset.cartRemove, quantity: 0 })
        });
        if (!response.ok) throw new Error('Cart update failed');
        window.location.reload();
      } catch (error) {
        window.location.href = link.href;
      }
    });
  });


  const mainSubmit = document.querySelector('.product-submit');
  const sticky = document.querySelector('.sticky-atc');
  if (mainSubmit && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver((entries) => sticky.classList.toggle('is-visible', !entries[0].isIntersecting), { threshold: 0 }).observe(mainSubmit);
    sticky.querySelector('button')?.addEventListener('click', () => mainSubmit.click());
  }

  const banner = document.querySelector('[data-consent-banner]');
  const consentKey = 'af-consent-v2';
  const setConsent = (accepted) => {
    const choice = accepted ? 'accepted' : 'necessary';
    try { localStorage.setItem(consentKey, choice); } catch (error) {}
    if (banner) banner.hidden = true;
    if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.setTrackingConsent) {
      Shopify.customerPrivacy.setTrackingConsent(accepted, () => { if (banner) banner.hidden = true; });
    }
  };
  if (banner) {
    let savedConsent = '';
    try { savedConsent = localStorage.getItem(consentKey) || localStorage.getItem('af-consent') || ''; } catch (error) {}
    if (savedConsent) {
      banner.hidden = true;
    } else {
      const show = () => {
        let shouldShow = true;
        if (window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.shouldShowBanner) {
          shouldShow = Shopify.customerPrivacy.shouldShowBanner();
        }
        banner.hidden = !shouldShow;
      };
      if (window.Shopify && Shopify.loadFeatures) Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], show);
      else show();
    }
    banner.querySelector('[data-consent-accept]')?.addEventListener('click', () => setConsent(true));
    banner.querySelector('[data-consent-decline]')?.addEventListener('click', () => setConsent(false));
  }
})();

(() => {
  const desktopMega = document.querySelector('.mega-menu');
  if (!desktopMega || !window.matchMedia('(min-width: 990px)').matches) return;
  let closeTimer;
  const openMega = () => { clearTimeout(closeTimer); desktopMega.open = true; };
  const closeMega = () => { closeTimer = window.setTimeout(() => { if (!desktopMega.matches(':focus-within')) desktopMega.open = false; }, 120); };
  desktopMega.addEventListener('mouseenter', openMega);
  desktopMega.addEventListener('mouseleave', closeMega);
  desktopMega.addEventListener('focusin', openMega);
  desktopMega.addEventListener('focusout', closeMega);
  desktopMega.querySelector(':scope > summary')?.addEventListener('click', (event) => {
    event.preventDefault();
    desktopMega.open = !desktopMega.open;
  });
})();

(() => {
  const moneyPdp = (cents) => new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON', maximumFractionDigits: 0 }).format(cents / 100);
  const rootUrlPdp = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  document.querySelectorAll('[data-pdp-root]').forEach((root) => {
    const form = root.querySelector('[data-pdp-form]');
    const json = root.querySelector('[data-pdp-variants]');
    if (!form || !json) return;

    let variants = [];
    try { variants = JSON.parse(json.textContent); } catch (error) { return; }

    const optionInputs = Array.from(root.querySelectorAll('[data-option-input]'));
    const idInput = form.querySelector('[name="id"]');
    const price = root.querySelector('[data-pdp-price]');
    const total = root.querySelector('[data-pdp-total]');
    const mobileTotal = root.querySelector('[data-pdp-mobile-total]');
    const submit = root.querySelector('[data-pdp-submit]');
    const errorBox = root.querySelector('[data-pdp-error]');
    let activeVariant = variants.find((item) => String(item.id) === String(idInput.value)) || variants[0];

    const selectedOptions = () => Array.from(root.querySelectorAll('[data-option-group]')).map((group) => group.querySelector('[data-option-input]:checked')?.value || group.querySelector('select[data-option-input]')?.value);

    const addonsTotal = () => Array.from(root.querySelectorAll('[data-pdp-addon-id]:checked')).reduce((sum, item) => sum + Number(item.dataset.pdpAddonPrice || 0), 0);

    const refreshTotal = () => {
      const amount = Number(activeVariant?.price || 0) + addonsTotal();
      if (total) total.textContent = moneyPdp(amount);
      if (mobileTotal) mobileTotal.textContent = moneyPdp(amount);
    };

    const updateVariant = (syncGallery = true) => {
      const selected = selectedOptions();
      const found = selected.length ? variants.find((item) => item.options.every((value, index) => value === selected[index])) : (variants.find((item) => String(item.id) === String(idInput.value)) || variants[0]);
      if (!found) {
        submit.disabled = true;
        submit.querySelector('span').textContent = 'Combinație indisponibilă';
        return;
      }
      activeVariant = found;
      idInput.value = found.id;
      if (syncGallery !== false && found.featured_media?.id) {
        const mediaSlide = root.querySelector('[data-gallery-slide][data-media-id="' + found.featured_media.id + '"]');
        if (mediaSlide) showGallerySlide(mediaSlide.dataset.gallerySlide);
      }
      refreshGalleryLabel();
      if (price) price.innerHTML = moneyPdp(found.price) + (found.compare_at_price && found.compare_at_price > found.price ? '<s>' + moneyPdp(found.compare_at_price) + '</s>' : '');
      submit.disabled = !found.available;
      submit.querySelector('span').textContent = found.available ? 'Adaugă în coș' : 'Indisponibil momentan';
      const stock = root.querySelector('[data-pdp-stock]');
      if (stock) {
        stock.classList.toggle('is-unavailable', !found.available);
        const stockText = stock.querySelector('span');
        if (stockText) stockText.textContent = found.available ? 'Poate fi comandat acum' : 'Indisponibil momentan';
      }
      const pageUrl = new URL(window.location.href);
      pageUrl.searchParams.set('variant', found.id);
      history.replaceState({}, '', pageUrl);
      refreshTotal();
    };

    optionInputs.forEach((input) => input.addEventListener('change', updateVariant));

    root.querySelectorAll('[data-pdp-addon-id]').forEach((input) => {
      input.addEventListener('change', () => {
        input.closest('.pdp-addon')?.classList.toggle('is-selected', input.checked);
        refreshTotal();
      });
    });

    const gallerySlides = Array.from(root.querySelectorAll('[data-gallery-slide]'));
    const galleryThumbs = Array.from(root.querySelectorAll('[data-gallery-thumb]'));
    const galleryLabel = root.querySelector('[data-gallery-variant]');
    const variantsForSlide = (slide) => slide ? variants.filter((variant) =>
      variant.featured_media?.id && String(variant.featured_media.id) === slide.dataset.mediaId
    ) : [];
    const refreshGalleryLabel = () => {
      if (!galleryLabel) return;
      const slide = gallerySlides.find((item) => !item.hidden);
      const assigned = variantsForSlide(slide);
      const pictured = assigned.find((item) => String(item.id) === String(activeVariant?.id)) || assigned[0];
      const title = pictured?.title === 'Default Title' ? '' : pictured?.title || '';
      galleryLabel.textContent = title;
      galleryLabel.hidden = !title;
    };
    const showGallerySlide = (index) => {
      const target = gallerySlides.find((slide) => slide.dataset.gallerySlide === String(index));
      if (!target) return;
      gallerySlides.forEach((slide) => {
        slide.hidden = slide !== target;
        slide.classList.toggle('is-active', slide === target);
      });
      galleryThumbs.forEach((thumb) => {
        const selected = thumb.dataset.galleryThumb === String(index);
        thumb.classList.toggle('is-active', selected);
        thumb.setAttribute('aria-pressed', String(selected));
      });
      const counter = root.querySelector('[data-gallery-current]');
      if (counter) counter.textContent = String(Number(index) + 1);
      refreshGalleryLabel();
    };
    galleryThumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const slide = gallerySlides.find((item) => item.dataset.gallerySlide === thumb.dataset.galleryThumb);
        const assigned = variantsForSlide(slide);
        const current = assigned.find((item) => String(item.id) === String(activeVariant?.id));
        const score = (variant) => variant.options.reduce((sum, value, index) =>
          sum + Number(value === activeVariant?.options[index]), 0);
        const candidates = assigned.filter((item) => item.available);
        const pool = candidates.length ? candidates : assigned;
        const target = current || pool.reduce((best, item) => !best || score(item) > score(best) ? item : best, null);
        if (target && String(target.id) !== String(activeVariant?.id)) {
          Array.from(root.querySelectorAll('[data-option-group]')).forEach((group, index) => {
            group.querySelectorAll('[data-option-input]').forEach((input) => {
              if (input.tagName === 'SELECT') input.value = target.options[index];
              else input.checked = input.value === target.options[index];
            });
          });
          idInput.value = target.id;
          updateVariant(false);
        }
        showGallerySlide(thumb.dataset.galleryThumb);
      });
    });

    root.querySelectorAll('[data-receive-method]').forEach((input) => {
      input.addEventListener('change', () => {
        const helper = root.querySelector('[data-date-helper]');
        if (helper) helper.textContent = input.value.includes('Ridicare') ? 'Spune-ne când vii la florărie' : 'Programăm livrarea când îți este potrivit';
      });
    });

    const dateInput = root.querySelector('[data-pdp-date]');
    const slotInput = root.querySelector('[data-delivery-slot-input]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const scheduleState = root.querySelector('[data-delivery-scheduler]');
      const scheduledDate = scheduleState?.dataset.selectedDate || dateInput?.value || '';
      const scheduledSlot = scheduleState?.dataset.selectedSlot || slotInput?.value || '';
      if (scheduledDate && scheduledSlot) {
        const methodCode = root.querySelector('[data-receive-method]:checked')?.dataset.buuntoMethod || 'LOCAL_DELIVERY';
        const dateProperty = form.querySelector('[data-buunto-date-input]');
        const selectionProperty = form.querySelector('[data-buunto-selection]');
        const displayDate = new Intl.DateTimeFormat('ro-RO', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(scheduledDate + 'T12:00:00'));
        if (dateInput) dateInput.value = scheduledDate;
        if (slotInput) slotInput.value = scheduledSlot;
        if (dateProperty) dateProperty.value = displayDate;
        if (selectionProperty) selectionProperty.value = methodCode + '|' + scheduledDate + '|' + scheduledSlot + '|';
      }
      if (!form.reportValidity() || !activeVariant?.available) return;
      if (!dateInput?.value || !slotInput?.value) {
        const schedulerError = root.querySelector('[data-delivery-error]');
        if (schedulerError) schedulerError.hidden = false;
        root.querySelector('[data-delivery-open]')?.click();
        return;
      }
      if (errorBox) errorBox.hidden = true;
      submit.disabled = true;
      submit.querySelector('span').textContent = 'Se adaugă…';

      const data = new FormData(form);
      const properties = {};
      data.forEach((value, key) => {
        const match = key.match(/^properties\[(.+)\]$/);
        if (match && value) properties[match[1]] = value;
      });

      const items = [{ id: Number(idInput.value), quantity: 1, properties: properties }];
      root.querySelectorAll('[data-pdp-addon-id]:checked').forEach((addon) => {
        items.push({ id: Number(addon.dataset.pdpAddonId), quantity: 1, properties: { 'Cadou pentru': root.dataset.productTitle } });
      });

      try {
        const response = await fetch(rootUrlPdp + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        });
        if (!response.ok) throw new Error('add failed');
        const deliveryAttributes = {
          'Metodă': root.querySelector('[data-receive-method]:checked')?.value || '',
          'Data livrarii': form.querySelector('[data-buunto-date-input]')?.value || '',
          'Ora livrarii': form.querySelector('[data-delivery-slot-input]')?.value || '',
          '__buunto_selection': form.querySelector('[data-buunto-selection]')?.value || ''
        };
        const attributesResponse = await fetch(rootUrlPdp + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes: deliveryAttributes })
        });
        if (!attributesResponse.ok) throw new Error('delivery attributes failed');
        window.location.href = rootUrlPdp + 'cart';
      } catch (error) {
        submit.disabled = false;
        submit.querySelector('span').textContent = 'Adaugă în coș';
        if (errorBox) errorBox.hidden = false;
      }
    });

    const mobileSubmit = root.querySelector('[data-pdp-mobile-submit]');
    mobileSubmit?.addEventListener('click', () => submit.click());

    updateVariant();
  });
})();


(() => {
  document.querySelectorAll('[data-pdp-root]').forEach((root) => {
    const submit = root.querySelector('[data-pdp-submit]');
    const bar = root.querySelector('[data-pdp-mobile-bar]');
    if (!submit || !bar) return;
    const touchViewport = window.matchMedia('(hover: none) and (pointer: coarse)');
    let viewportWidth = window.innerWidth;
    let stableHeight = window.innerHeight;
    let pendingFrame = 0;
    const syncPdpBar = () => {
      pendingFrame = 0;
      const rect = submit.getBoundingClientRect();
      const height = touchViewport.matches ? stableHeight : window.innerHeight;
      const footer = document.querySelector('.site-footer');
      const footerVisible = footer && footer.getBoundingClientRect().top < height;
      const visible = bar.classList.contains('is-visible');
      const gap = visible ? 0 : 16;
      const outside = rect.bottom < -gap || rect.top > height + gap;
      const editing = document.activeElement?.matches('input:not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]');
      bar.classList.toggle('is-visible', outside && !footerVisible && !editing);
    };
    const queuePdpBar = () => {
      if (!pendingFrame) pendingFrame = window.requestAnimationFrame(syncPdpBar);
    };
    window.addEventListener('scroll', queuePdpBar, { passive: true });
    window.addEventListener('resize', () => {
      if (Math.abs(window.innerWidth - viewportWidth) > 32) {
        viewportWidth = window.innerWidth;
        stableHeight = window.innerHeight;
      }
      queuePdpBar();
    }, { passive: true });
    document.addEventListener('focusin', queuePdpBar);
    document.addEventListener('focusout', queuePdpBar);
    window.addEventListener('pageshow', queuePdpBar);
    window.setTimeout(queuePdpBar, 120);
  });
})();


(() => {
  document.querySelectorAll('.product-grid').forEach((grid) => {
    const cards = Array.from(grid.querySelectorAll('[data-product-card]'));
    cards.sort((a, b) => Number(b.dataset.available === 'true') - Number(a.dataset.available === 'true'));
    cards.forEach((card) => grid.appendChild(card));
  });

  document.querySelectorAll('[data-review-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-review-track]');
    const prev = slider.querySelector('[data-review-prev]');
    const next = slider.querySelector('[data-review-next]');
    if (!track) return;
    const move = (direction) => {
      const slide = track.querySelector('.review-slide');
      const gap = 14;
      track.scrollBy({ left: direction * ((slide?.getBoundingClientRect().width || 320) + gap), behavior: 'smooth' });
    };
    prev?.addEventListener('click', () => move(-1));
    next?.addEventListener('click', () => move(1));
  });
})();


(() => {
  const prepareExpandableReviews = () => {
    document.querySelectorAll('[data-review-card]').forEach((card) => {
      const text = card.querySelector('.review-slide__text');
      const more = card.querySelector('.review-slide__more');
      if (!text || !more) return;
      const wasExpanded = card.classList.contains('is-expanded');
      card.classList.remove('is-expanded');
      const collapsedHeight = text.getBoundingClientRect().height;
      card.classList.add('is-expanded');
      const naturalHeight = text.getBoundingClientRect().height;
      card.classList.remove('is-expanded');
      const expandable = naturalHeight > collapsedHeight + 2;
      card.classList.toggle('is-expandable', expandable);
      card.tabIndex = expandable ? 0 : -1;
      more.hidden = !expandable;
      if (!expandable) {
        card.setAttribute('aria-expanded', 'false');
        more.textContent = 'Citește toată recenzia';
      } else if (wasExpanded) {
        card.classList.add('is-expanded');
      }
    });
  };

  const toggleReview = (card) => {
    if (!card.classList.contains('is-expandable')) return;
    const expanded = card.classList.toggle('is-expanded');
    card.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    const more = card.querySelector('.review-slide__more');
    if (more) more.textContent = expanded ? 'Restrânge recenzia' : 'Citește toată recenzia';
  };

  document.querySelectorAll('[data-review-card]').forEach((card) => {
    card.addEventListener('click', (event) => {
      if (event.target.closest('a')) return;
      toggleReview(card);
    });
    card.addEventListener('keydown', (event) => {
      if (event.target !== card || (event.key !== 'Enter' && event.key !== ' ')) return;
      event.preventDefault();
      toggleReview(card);
    });
  });

  window.addEventListener('load', prepareExpandableReviews, { once: true });
  let reviewResizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(reviewResizeTimer);
    reviewResizeTimer = setTimeout(prepareExpandableReviews, 120);
  });
  prepareExpandableReviews();
})();

(() => {
  document.querySelectorAll('[data-review-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-review-track]');
    const status = slider.querySelector('[data-review-status]');
    if (!track || !status) return;
    let frame;
    const updateStatus = () => {
      const cards = Array.from(track.querySelectorAll('.review-slide'));
      if (!cards.length) return;
      const firstWidth = cards[0].getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap) || 14;
      const step = firstWidth + gap;
      const first = Math.min(cards.length, Math.max(1, Math.round(track.scrollLeft / step) + 1));
      const visible = Math.max(1, Math.floor((track.clientWidth + gap) / step));
      status.textContent = first + '–' + Math.min(cards.length, first + visible - 1) + ' din ' + cards.length;
    };
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(updateStatus);
    }, { passive: true });
    window.addEventListener('resize', updateStatus);
    updateStatus();
  });
})();

/* Predictive product search — native Shopify endpoint */
(() => {
  const aliases = {
    trand: 'trandafiri', trandafir: 'trandafiri', trandaf: 'trandafiri',
    buchet: 'buchete', buche: 'buchete', hort: 'hortensie',
    bujor: 'bujori', crin: 'crini', cadou: 'cadouri', planta: 'plante'
  };
  const expandQuery = (value) => {
    const clean = value.trim().toLocaleLowerCase('ro-RO').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const key = Object.keys(aliases).find((item) => clean === item || clean.startsWith(item));
    return key ? aliases[key] : value.trim();
  };
  const money = (value) => {
    const amount = Number(value);
    return Number.isFinite(amount) ? new Intl.NumberFormat('ro-RO', { style: 'currency', currency: 'RON', maximumFractionDigits: 0 }).format(amount) : '';
  };
  const make = (tag, className, textValue) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (textValue) element.textContent = textValue;
    return element;
  };

  document.querySelectorAll('[data-predictive-search]').forEach((root) => {
    const input = root.querySelector('[data-predictive-input]');
    const results = root.querySelector('[data-predictive-results]');
    const form = root.querySelector('[data-predictive-form]');
    let timer;
    let controller;

    const render = (products, rawQuery) => {
      results.replaceChildren();
      if (!products.length) {
        const empty = make('div', 'predictive-results__empty');
        empty.append(make('strong', '', 'Nu am găsit un produs exact.'));
        empty.append(make('p', '', 'Încearcă „trandafiri”, „buchet roz” sau vezi toate rezultatele.'));
        const link = make('a', 'text-link', 'Caută în tot magazinul →');
        link.href = '/search?q=' + encodeURIComponent(rawQuery);
        empty.append(link);
        results.append(empty);
        return;
      }
      const grid = make('div', 'predictive-results__grid');
      products.slice(0, 6).forEach((product) => {
        const link = make('a', 'predictive-product');
        link.href = product.url;
        if (product.image) {
          const image = document.createElement('img');
          image.src = product.image;
          image.alt = product.title || '';
          image.loading = 'lazy';
          link.append(image);
        } else {
          link.append(make('span', 'predictive-product__placeholder', 'AF'));
        }
        const copy = make('span', 'predictive-product__copy');
        copy.append(make('strong', '', product.title));
        copy.append(make('small', '', money(product.price)));
        link.append(copy);
        grid.append(link);
      });
      results.append(grid);
      const all = make('a', 'predictive-results__all', 'Vezi toate rezultatele pentru „' + rawQuery + '” →');
      all.href = '/search?q=' + encodeURIComponent(expandQuery(rawQuery));
      results.append(all);
    };

    const search = async () => {
      const raw = input.value.trim();
      if (raw.length < 2) {
        results.innerHTML = '<p>Scrie cel puțin două litere și îți arătăm imediat produsele potrivite.</p>';
        return;
      }
      controller?.abort();
      controller = new AbortController();
      results.innerHTML = '<p class="predictive-results__loading">Căutăm cele mai potrivite produse…</p>';
      const query = expandQuery(raw);
      try {
        const base = window.Shopify?.routes?.root || '/';
        const response = await fetch(base + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', { signal: controller.signal });
        if (!response.ok) throw new Error('search');
        const data = await response.json();
        render(data?.resources?.results?.products || [], raw);
      } catch (error) {
        if (error.name !== 'AbortError') results.innerHTML = '<p>Nu am putut încărca sugestiile. Apasă Caută pentru rezultate.</p>';
      }
    };

    input?.addEventListener('input', () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(search, 180);
    });
    form?.addEventListener('submit', () => { input.value = expandQuery(input.value); });
    root.querySelectorAll('[data-search-term]').forEach((button) => button.addEventListener('click', () => {
      input.value = button.dataset.searchTerm;
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.focus();
    }));
    root.querySelector('[data-search-close]')?.addEventListener('click', () => root.removeAttribute('open'));
    root.addEventListener('toggle', () => {
      if (root.open) window.setTimeout(() => input?.focus(), 40);
      else root.querySelector(':scope > summary')?.focus();
    });
    root.querySelector('.search-popover__panel')?.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab' || !root.open) return;
      const focusable = Array.from(root.querySelectorAll('.search-popover__panel button:not([disabled]),.search-popover__panel a[href],.search-popover__panel input:not([disabled])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  });
})();


/* Delivery calendar synchronized with Buunto availability. */
(() => {
  const parseDate = (value) => new Date(value + 'T12:00:00');
  const isoLocal = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  };
  const startOfDay = (date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

  document.querySelectorAll('[data-delivery-scheduler]').forEach((scheduler) => {
    const modal = scheduler.querySelector('[data-delivery-modal]');
    const dialog = scheduler.querySelector('.delivery-scheduler__dialog');
    const openButton = scheduler.querySelector('[data-delivery-open]');
    const dateInput = scheduler.querySelector('[data-pdp-date]');
    const slotInput = scheduler.querySelector('[data-delivery-slot-input]');
    const monthLabel = scheduler.querySelector('[data-calendar-month]');
    const days = scheduler.querySelector('[data-calendar-days]');
    const previous = scheduler.querySelector('[data-calendar-prev]');
    const next = scheduler.querySelector('[data-calendar-next]');
    const confirm = scheduler.querySelector('[data-delivery-confirm]');
    const title = scheduler.querySelector('[data-delivery-title]');
    const summary = scheduler.querySelector('[data-delivery-summary]');
    const action = scheduler.querySelector('[data-delivery-action]');
    const modalSummary = scheduler.querySelector('[data-delivery-modal-summary]');
    const error = scheduler.querySelector('[data-delivery-error]');
    const slotGrid = scheduler.querySelector('.delivery-slots__grid');
    if (!modal || !dialog || !openButton || !dateInput || !slotInput || !days || !confirm || !slotGrid) return;

    const fallbackSlots = Array.from(slotGrid.querySelectorAll('[data-delivery-slot]')).map((button) => ({
      from: button.dataset.deliverySlot.split(/[–—-]/)[0].trim(),
      to: button.dataset.deliverySlot.split(/[–—-]/)[1].trim(),
      formatted: button.dataset.deliverySlot
    }));
    const minimum = startOfDay(new Date());
    let selectedDate = '';
    let selectedSlot = '';
    let availability = {};
    let availabilityReady = false;
    let loading = false;
    let view = new Date(minimum.getFullYear(), minimum.getMonth(), 1);

    const method = () => scheduler.closest('[data-pdp-root]')?.querySelector('[data-receive-method]:checked')?.dataset.buuntoMethod || 'LOCAL_DELIVERY';
    const entries = () => Array.isArray(availability[method()]) ? availability[method()] : [];
    const entryFor = (date) => entries().find((entry) => entry.date === date);
    const formatDate = (value, short = false) => new Intl.DateTimeFormat('ro-RO', short
      ? { weekday: 'short', day: '2-digit', month: 'short' }
      : { weekday: 'long', day: '2-digit', month: 'long' }).format(parseDate(value));

    const makeSlotButton = (slot, disabled = false) => {
      const button = document.createElement('button');
      button.type = 'button';
      const from = slot.from || String(slot.formatted || '').split(/[–—-]/)[0].trim();
      const to = slot.to || String(slot.formatted || '').split(/[–—-]/)[1].trim();
      const display = slot.formatted || (from + ' - ' + to);
      button.dataset.deliverySlot = display;
      button.dataset.slotStart = String(Number((from || '0').split(':')[0]));
      const nowParts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Bucharest', year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
      }).formatToParts(new Date()).filter((part) => part.type !== 'literal').map((part) => [part.type, part.value]));
      const todayInRomania = nowParts.year + '-' + nowParts.month + '-' + nowParts.day;
      const currentMinutes = Number(nowParts.hour) * 60 + Number(nowParts.minute);
      const startParts = String(from || '0:0').split(':');
      const startMinutes = Number(startParts[0]) * 60 + Number(startParts[1] || 0);
      const isPast = selectedDate === todayInRomania && startMinutes <= currentMinutes;
      const isWaiting = disabled && !selectedDate;
      const unavailable = disabled || !!slot.disabled || !!slot.soldOut || isPast;
      button.disabled = unavailable;
      if (isPast) button.classList.add('is-past');
      else if (slot.soldOut) button.classList.add('is-sold-out');
      else if (unavailable && !isWaiting) button.classList.add('is-unavailable');
      else if (isWaiting) button.classList.add('is-waiting');
      const statusText = isPast ? 'interval trecut' : slot.soldOut ? 'interval ocupat' : unavailable ? (isWaiting ? 'alege mai întâi ziua' : 'interval indisponibil') : 'interval disponibil';
      button.setAttribute('aria-label', display + ', ' + statusText);
      button.append(document.createTextNode(from + ' '));
      const separator = document.createElement('span');
      separator.textContent = '–';
      button.append(separator, document.createTextNode(' ' + to));
      button.addEventListener('click', () => {
        selectedSlot = display;
        sync();
      });
      return button;
    };

    const renderSlots = () => {
      slotGrid.replaceChildren();
      let slots = fallbackSlots;
      if (availabilityReady) {
        const entry = entryFor(selectedDate);
        slots = entry?.timeSlots || [];
      }
      if (!selectedDate) {
        const prompt = document.createElement('div');
        prompt.className = 'delivery-slots__date-prompt';
        prompt.setAttribute('role', 'status');
        prompt.innerHTML = '<span aria-hidden="true">↖</span><div><strong>Alege data livrării</strong><small>Intervalele disponibile vor apărea aici.</small></div>';
        slotGrid.append(prompt);
        return;
      }
      if (!slots.length) {
        const empty = document.createElement('p');
        empty.className = 'delivery-slots__empty';
        empty.textContent = loading ? 'Verificăm intervalele disponibile…' : 'Nu există intervale disponibile pentru această zi.';
        slotGrid.append(empty);
        selectedSlot = '';
        return;
      }
      slots.forEach((slot) => slotGrid.append(makeSlotButton(slot)));
    };

    const loadSlotsForDate = async () => {
      const entry = entryFor(selectedDate);
      if (!availabilityReady || !entry || Array.isArray(entry.timeSlots)) return;
      const shop = scheduler.dataset.buuntoShop;
      const variantId = scheduler.closest('[data-pdp-root]')?.querySelector('[data-pdp-form] [name="id"]')?.value;
      loading = true;
      renderSlots();
      sync();
      try {
        const params = new URLSearchParams({ shop, date: selectedDate, method: method() });
        if (variantId) params.set('productVariantIds', variantId);
        const response = await fetch('https://datepicker.buunto.com/api/v1/available_time_slots?' + params.toString(), {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Buunto slots ' + response.status);
        entry.timeSlots = await response.json();
      } catch (requestError) {
        entry.timeSlots = fallbackSlots;
        console.warn('Intervalele Buunto nu au putut fi încărcate; folosim intervalele de rezervă.', requestError);
      } finally {
        loading = false;
        renderSlots();
        sync();
      }
    };

    const sync = () => {
      const buttons = Array.from(slotGrid.querySelectorAll('[data-delivery-slot]'));
      if (selectedSlot && !buttons.some((button) => button.dataset.deliverySlot === selectedSlot && !button.disabled)) selectedSlot = '';
      const complete = !!selectedDate && !!selectedSlot && !loading;
      confirm.disabled = !complete;
      modalSummary.textContent = loading
        ? 'Verificăm disponibilitatea Buunto…'
        : complete
          ? formatDate(selectedDate) + ' · ' + selectedSlot
          : selectedDate
            ? formatDate(selectedDate) + ' · alege intervalul'
            : 'Alege data pentru a vedea intervalele disponibile.';
      buttons.forEach((button) => button.classList.toggle('is-selected', !button.disabled && button.dataset.deliverySlot === selectedSlot));
    };

    const render = () => {
      monthLabel.textContent = new Intl.DateTimeFormat('ro-RO', { month: 'long', year: 'numeric' }).format(view);
      days.replaceChildren();
      const first = new Date(view.getFullYear(), view.getMonth(), 1);
      const offset = (first.getDay() + 6) % 7;
      const count = new Date(view.getFullYear(), view.getMonth() + 1, 0).getDate();
      const availableEntries = entries().filter((entry) => !entry.soldOut);
      const lastAvailable = availableEntries.length ? parseDate(availableEntries[availableEntries.length - 1].date) : null;
      for (let blank = 0; blank < offset; blank += 1) days.append(document.createElement('span'));
      for (let day = 1; day <= count; day += 1) {
        const date = new Date(view.getFullYear(), view.getMonth(), day);
        const iso = isoLocal(date);
        const apiEntry = entryFor(iso);
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = String(day);
        button.dataset.date = iso;
        button.disabled = loading || (availabilityReady ? (!apiEntry || apiEntry.soldOut) : date < minimum);
        if (selectedDate === iso) button.classList.add('is-selected');
        if (iso === isoLocal(startOfDay(new Date()))) button.classList.add('is-today');
        button.addEventListener('click', () => {
          selectedDate = iso;
          selectedSlot = '';
          render();
          renderSlots();
          sync();
          loadSlotsForDate();
        });
        days.append(button);
      }
      previous.disabled = loading || (view.getFullYear() === minimum.getFullYear() && view.getMonth() === minimum.getMonth());
      next.disabled = loading || !!(availabilityReady && lastAvailable && (
        view.getFullYear() > lastAvailable.getFullYear() ||
        (view.getFullYear() === lastAvailable.getFullYear() && view.getMonth() >= lastAvailable.getMonth())
      ));
    };

    const resetForMethod = () => {
      selectedDate = '';
      selectedSlot = '';
      const firstAvailable = entries().find((entry) => !entry.soldOut);
      if (firstAvailable) {
        const date = parseDate(firstAvailable.date);
        view = new Date(date.getFullYear(), date.getMonth(), 1);
      }
      render();
      renderSlots();
      sync();
    };

    const loadAvailability = async () => {
      const shop = scheduler.dataset.buuntoShop;
      const variantId = scheduler.closest('[data-pdp-root]')?.querySelector('[data-pdp-form] [name="id"]')?.value;
      if (!shop) return;
      loading = true;
      days.setAttribute('aria-busy', 'true');
      render();
      sync();
      try {
        const params = new URLSearchParams({ shop, withTimeSlots: 'true' });
        if (variantId) params.set('productVariantIds', variantId);
        const response = await fetch('https://datepicker.buunto.com/api/v1/available_dates?' + params.toString(), {
          headers: { Accept: 'application/json' }
        });
        if (!response.ok) throw new Error('Buunto availability ' + response.status);
        availability = await response.json();
        availabilityReady = true;
      } catch (requestError) {
        availability = {};
        availabilityReady = false;
        console.warn('Disponibilitatea Buunto nu a putut fi încărcată; folosim intervalele de rezervă.', requestError);
      } finally {
        loading = false;
        days.removeAttribute('aria-busy');
        resetForMethod();
      }
    };

    const close = () => {
      modal.hidden = true;
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('is-delivery-scheduler-open', 'is-calendar-open', 'is-mobile-overlay-open');
      openButton.focus();
    };
    const open = () => {
      modal.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('is-delivery-scheduler-open', 'is-calendar-open', 'is-mobile-overlay-open');
      render();
      renderSlots();
      sync();
      window.setTimeout(() => dialog.querySelector('button:not([disabled])')?.focus(), 0);
    };

    openButton.addEventListener('click', open);
    scheduler.querySelectorAll('[data-delivery-close]').forEach((button) => button.addEventListener('click', close));
    previous?.addEventListener('click', () => { view = new Date(view.getFullYear(), view.getMonth() - 1, 1); render(); });
    next?.addEventListener('click', () => { view = new Date(view.getFullYear(), view.getMonth() + 1, 1); render(); });
    confirm.addEventListener('click', () => {
      if (!selectedDate || !selectedSlot) return;
      scheduler.dataset.selectedDate = selectedDate;
      scheduler.dataset.selectedSlot = selectedSlot;
      dateInput.value = selectedDate;
      slotInput.value = selectedSlot;
      if (title) title.textContent = formatDate(selectedDate, true);
      if (summary) summary.textContent = selectedSlot;
      if (action) action.textContent = 'Modifică';
      if (error) error.hidden = true;
      document.dispatchEvent(new CustomEvent('FlorariaIrinuca:deliverySelection', {
        detail: { method: method(), date: selectedDate, timeSlot: selectedSlot }
      }));
      close();
    });
    scheduler.closest('[data-pdp-root]')?.querySelectorAll('[data-receive-method]').forEach((input) => {
      input.addEventListener('change', resetForMethod);
    });
    scheduler.closest('[data-pdp-root]')?.querySelectorAll('[data-option-input]').forEach((input) => {
      input.addEventListener('change', loadAvailability);
    });
    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;
      const focusable = Array.from(dialog.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    document.addEventListener('keydown', (event) => { if (event.key === 'Escape' && !modal.hidden) close(); });
    renderSlots();
    loadAvailability();
  });
})();


/* Product gallery: arrows and horizontal swipe */
(() => {
  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    const stage = gallery.querySelector('.pdp-gallery__stage');
    const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
    if (!stage || thumbs.length < 2) return;
    const activeIndex = () => Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
    const go = (delta) => thumbs[(activeIndex() + delta + thumbs.length) % thumbs.length]?.click();
    gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => go(-1));
    gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => go(1));

    let startX = 0;
    let startY = 0;
    let tracking = false;
    let suppressClickUntil = 0;
    stage.addEventListener('click', (event) => {
      if (Date.now() < suppressClickUntil && event.target.closest('[data-gallery-zoom]')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    stage.addEventListener('touchcancel', () => { tracking = false; }, { passive: true });
    stage.addEventListener('touchstart', (event) => {
      tracking = event.touches.length === 1;
      if (!tracking) return;
      const touch = event.changedTouches[0];
      startX = touch.clientX;
      startY = touch.clientY;
    }, { passive: true });
    stage.addEventListener('touchend', (event) => {
      if (!tracking || event.touches.length) { tracking = false; return; }
      tracking = false;
      const touch = event.changedTouches[0];
      const dx = touch.clientX - startX;
      const dy = touch.clientY - startY;
      if (Math.abs(dx) > 42 && Math.abs(dx) > Math.abs(dy) * 1.15) {
        suppressClickUntil = Date.now() + 500;
        go(dx < 0 ? 1 : -1);
      }
    }, { passive: true });
  });
})();


/* Mobile overlay coordination and safe viewport behavior */
(() => {
  const isMobile = () => window.matchMedia('(max-width: 749px)').matches;
  const syncLock = () => {
    if (!isMobile()) {
      document.body.classList.remove('is-mobile-overlay-open');
      return;
    }
    const menuOpen = !!document.querySelector('.mobile-menu[open]');
    const searchOpen = !!document.querySelector('.search-popover[open]');
    const filtersOpen = !!document.querySelector('.filters.is-open');
    const calendarOpen = document.body.classList.contains('is-calendar-open');
    document.body.classList.toggle('is-mobile-overlay-open', menuOpen || searchOpen || filtersOpen || calendarOpen);
  };
  document.querySelectorAll('.mobile-menu,.search-popover').forEach((details) => details.addEventListener('toggle', syncLock));
  document.querySelectorAll('[data-mobile-filter],[data-calendar-toggle],[data-calendar-close],[data-calendar-days]').forEach((control) => control.addEventListener('click', () => window.setTimeout(syncLock, 0)));
  window.addEventListener('resize', syncLock, { passive: true });
  window.addEventListener('pageshow', syncLock);
  syncLock();
})();


/* Dual-handle collection price range */
(() => {
  document.querySelectorAll('[data-price-range]').forEach((range) => {
    const min = range.querySelector('[data-price-min]');
    const max = range.querySelector('[data-price-max]');
    const minOutput = range.querySelector('[data-price-min-output]');
    const maxOutput = range.querySelector('[data-price-max-output]');
    const fill = range.querySelector('[data-price-fill]');
    if (!min || !max) return;
    const format = (value) => new Intl.NumberFormat('ro-RO', { maximumFractionDigits: 0 }).format(Number(value)) + ' lei';
    const sync = (source) => {
      const gap = Math.min(10, Number(max.max || 0));
      if (source === min && Number(min.value) > Number(max.value) - gap) min.value = String(Math.max(0, Number(max.value) - gap));
      if (source === max && Number(max.value) < Number(min.value) + gap) max.value = String(Math.min(Number(max.max), Number(min.value) + gap));
      const ceiling = Number(max.max) || 1;
      if (minOutput) minOutput.textContent = format(min.value);
      if (maxOutput) maxOutput.textContent = format(max.value);
      if (fill) {
        fill.style.left = (Number(min.value) / ceiling * 100) + '%';
        fill.style.right = (100 - Number(max.value) / ceiling * 100) + '%';
      }
    };
    min.addEventListener('input', () => sync(min));
    max.addEventListener('input', () => sync(max));
    sync();
  });
})();


/* Reliable mobile navigation hit areas */
(() => {
  const selector = '.mobile-menu__panel a[href], .collection-categories a[href]';
  document.addEventListener('click', (event) => {
    if (!window.matchMedia('(max-width: 989px)').matches) return;
    const link = event.target.closest(selector);
    if (!link || !link.href) return;
    event.preventDefault();
    window.location.assign(link.href);
  }, true);
})();




/* Stock-aware collection pagination with inactive page templates. */
(() => {
  document.querySelectorAll('[data-stock-aware-grid]').forEach((grid) => {
    const templateRoot = grid.parentElement?.querySelector('[data-stock-page-templates]');
    const templates = templateRoot ? Array.from(templateRoot.querySelectorAll('template[data-stock-page]')) : [];
    const nav = grid.parentElement?.querySelector('[data-stock-pagination]');
    if (!templates.length || !nav) return;

    const pages = templates.length;
    const pageFromUrl = () => {
      const value = Number(new URL(window.location.href).searchParams.get('page') || 1);
      return Math.min(pages, Math.max(1, Number.isFinite(value) ? value : 1));
    };
    let page = pageFromUrl();

    const pageHref = (target) => {
      const url = new URL(window.location.href);
      if (target <= 1) url.searchParams.delete('page');
      else url.searchParams.set('page', String(target));
      return url.pathname + url.search;
    };

    const makeLink = (label, target, current = false, ariaLabel = '') => {
      const link = document.createElement('a');
      link.href = pageHref(target);
      link.textContent = label;
      link.dataset.page = String(target);
      if (current) {
        link.classList.add('is-current');
        link.setAttribute('aria-current', 'page');
      }
      if (ariaLabel) link.setAttribute('aria-label', ariaLabel);
      if (target < 1 || target > pages) {
        link.setAttribute('aria-disabled', 'true');
        link.tabIndex = -1;
      } else {
        link.addEventListener('click', (event) => {
          event.preventDefault();
          showPage(target, true, true);
        });
      }
      return link;
    };

    const renderNav = () => {
      nav.replaceChildren();
      nav.hidden = pages <= 1;
      if (pages <= 1) return;
      nav.appendChild(makeLink('←', page - 1, false, 'Pagina anterioară'));
      for (let index = 1; index <= pages; index += 1) {
        nav.appendChild(makeLink(String(index), index, index === page, 'Pagina ' + index));
      }
      nav.appendChild(makeLink('→', page + 1, false, 'Pagina următoare'));
    };

    const showPage = (target, shouldScroll = false, pushHistory = false) => {
      page = Math.min(pages, Math.max(1, target));
      const template = templates[page - 1];
      grid.replaceChildren(template.content.cloneNode(true));
      renderNav();
      if (pushHistory) window.history.pushState({ stockPage: page }, '', pageHref(page));
      if (shouldScroll) grid.parentElement?.querySelector('.collection-toolbar')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    window.addEventListener('popstate', () => showPage(pageFromUrl()));
    showPage(page);
  });
})();

/* Shopify policy pages: keep a single semantic H1. */
(() => {
  if (!document.body.classList.contains('template-policy')) return;
  const policyContainer = document.querySelector('.shopify-policy__container');
  if (!policyContainer) return;
  policyContainer.querySelectorAll('.shopify-policy__body h1').forEach((heading) => {
    const replacement = document.createElement('h2');
    for (const attribute of heading.attributes) replacement.setAttribute(attribute.name, attribute.value);
    replacement.innerHTML = heading.innerHTML;
    heading.replaceWith(replacement);
  });
})();


/* Product image lightbox. */
(() => {
  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    const lightbox = gallery.querySelector('[data-pdp-lightbox]');
    // Escape the gallery stacking context so zoom always covers the full viewport.
    if (lightbox && lightbox.parentElement !== document.body) document.body.appendChild(lightbox);
    const lightboxImage = lightbox?.querySelector('[data-lightbox-image]');
    const caption = lightbox?.querySelector('[data-lightbox-caption]');
    if (!lightbox || !lightboxImage) return;
    const mediaFrame = document.createElement('div');
    mediaFrame.className = 'pdp-lightbox__media';
    lightboxImage.before(mediaFrame);
    mediaFrame.appendChild(lightboxImage);
    const variantLabel = document.createElement('span');
    variantLabel.className = 'pdp-lightbox__variant';
    variantLabel.setAttribute('role', 'status');
    variantLabel.setAttribute('aria-live', 'polite');
    variantLabel.setAttribute('aria-atomic', 'true');
    variantLabel.hidden = true;
    mediaFrame.appendChild(variantLabel);
    let opener = null;

    const activeSlide = () => gallery.querySelector('[data-gallery-slide].is-active:not([hidden])') || gallery.querySelector('[data-gallery-slide]:not([hidden])');
    const syncImage = () => {
      const slide = activeSlide();
      const image = slide?.querySelector('img');
      if (!image) return;
      const zoomSource = slide.querySelector('[data-gallery-zoom]')?.dataset.lightboxSrc;
      lightboxImage.src = zoomSource || image.currentSrc || image.src;
      lightboxImage.alt = image.alt || '';
      if (caption) caption.textContent = image.alt || '';
      const galleryLabel = gallery.querySelector('[data-gallery-variant]');
      variantLabel.textContent = galleryLabel?.textContent || '';
      variantLabel.hidden = !galleryLabel || galleryLabel.hidden || !variantLabel.textContent;
    };
    const open = (button) => {
      opener = button;
      syncImage();
      lightbox.hidden = false;
      document.body.classList.add('is-lightbox-open');
      lightbox.querySelector('[data-lightbox-close]')?.focus();
    };
    const close = () => {
      lightbox.hidden = true;
      document.body.classList.remove('is-lightbox-open');
      opener?.focus();
    };
    const move = (direction) => {
      const thumbs = Array.from(gallery.querySelectorAll('[data-gallery-thumb]'));
      if (!thumbs.length) return;
      let index = thumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
      index = (Math.max(0, index) + direction + thumbs.length) % thumbs.length;
      thumbs[index].click();
      syncImage();
    };

    gallery.querySelectorAll('[data-gallery-zoom]').forEach((button) => button.addEventListener('click', () => open(button)));
    lightbox.querySelectorAll('[data-lightbox-close]').forEach((button) => button.addEventListener('click', close));
    lightbox.querySelector('[data-lightbox-prev]')?.addEventListener('click', () => move(-1));
    lightbox.querySelector('[data-lightbox-next]')?.addEventListener('click', () => move(1));
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') close();
      if (event.key === 'ArrowLeft') move(-1);
      if (event.key === 'ArrowRight') move(1);
      if (event.key !== 'Tab') return;
      const focusable = Array.from(lightbox.querySelectorAll('button:not([disabled])'));
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  });
})();


/* Official Buunto widget bridge. */
(() => {
  const placeholder = document.querySelector('[data-buunto-official]');
  const root = placeholder?.closest('[data-pdp-root]');
  const step = placeholder?.closest('.pdp-config-step--schedule');
  if (!placeholder || !root || !step) return;
  const scheduler = step.querySelector('[data-delivery-scheduler]');
  const form = root.querySelector('[data-pdp-form]');

  const syncWidgetState = () => {
    const mounted = placeholder.childElementCount > 0 || placeholder.textContent.trim().length > 0;
    step.classList.toggle('has-buunto-widget', mounted);
  };
  new MutationObserver(syncWidgetState).observe(placeholder, { childList: true, subtree: true, characterData: true });
  syncWidgetState();

  const keepGalleryInteractive = () => {
    root.querySelectorAll('[data-gallery-zoom],[data-gallery-thumb],[data-gallery-prev],[data-gallery-next],[data-lightbox-close],[data-lightbox-prev],[data-lightbox-next]').forEach((button) => {
      if (button.hasAttribute('data-buunto-invalid-selection-disabled')) {
        button.disabled = false;
        button.removeAttribute('data-buunto-invalid-selection-disabled');
      }
    });
  };
  new MutationObserver(keepGalleryInteractive).observe(root, { subtree: true, attributes: true, attributeFilter: ['disabled', 'data-buunto-invalid-selection-disabled'] });
  keepGalleryInteractive();

  const applySelection = (selection = {}) => {
    const date = selection.date || '';
    const dateDisplay = selection.dateDisplay || date;
    const slotDisplay = selection.timeSlotDisplay || (selection.timeSlot
      ? [selection.timeSlot.from, selection.timeSlot.to].filter(Boolean).join(' - ')
      : '');
    const method = selection.method || 'LOCAL_DELIVERY';
    const methodInput = root.querySelector('[data-receive-method][data-buunto-method="' + method + '"]');
    if (methodInput && !methodInput.checked) {
      methodInput.checked = true;
      methodInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (scheduler) {
      scheduler.dataset.selectedDate = date;
      scheduler.dataset.selectedSlot = slotDisplay;
    }
    const rawDate = form?.querySelector('[data-pdp-date]');
    const dateProperty = form?.querySelector('[data-buunto-date-input]');
    const slotProperty = form?.querySelector('[data-delivery-slot-input]');
    const selectionProperty = form?.querySelector('[data-buunto-selection]');
    if (rawDate) rawDate.value = date;
    if (dateProperty) dateProperty.value = dateDisplay;
    if (slotProperty) slotProperty.value = slotDisplay;
    if (selectionProperty) selectionProperty.value = date && slotDisplay ? method + '|' + date + '|' + slotDisplay + '|' : '';
    const title = step.querySelector('[data-delivery-title]');
    const summary = step.querySelector('[data-delivery-summary]');
    if (title) title.textContent = dateDisplay || 'Alege data și ora';
    if (summary) summary.textContent = slotDisplay || 'Nicio programare selectată';
    if (date && slotDisplay) step.querySelector('[data-delivery-error]')?.setAttribute('hidden', '');
    step.classList.add('has-buunto-widget');
  };

  const waitFor = (test, timeout = 5000) => new Promise((resolve) => {
    const started = Date.now();
    const check = () => {
      const value = test();
      if (value) return resolve(value);
      if (Date.now() - started >= timeout) return resolve(null);
      window.setTimeout(check, 100);
    };
    check();
  });

  const normalizeSlot = (value) => String(value || '').replace(/[–—]/g, '-').replace(/\s+/g, ' ').trim();

  const syncNativeSelectionToBuunto = async (selection) => {
    const date = selection?.date;
    const slot = normalizeSlot(selection?.timeSlot);
    if (!date || !slot) return;
    step.dataset.buuntoSaved = 'false';

    await waitFor(() => placeholder.childElementCount > 0);
    placeholder.querySelector('.buunto-order-selection-change')?.click();

    const api = await waitFor(() => window.Buunto?.datePicker?.selectDate && window.Buunto.datePicker);
    if (!api) return;
    try {
      await Promise.resolve(api.selectDate(date));
      const select = await waitFor(() => {
        const node = placeholder.querySelector('.buunto-time-slot-picker-dropdown, select[name="properties[Ora livrarii]"]');
        return node && node.options?.length ? node : null;
      });
      if (!select) return;
      const option = [...select.options].find((item) => normalizeSlot(item.textContent) === slot || normalizeSlot(item.value) === slot);
      if (!option) return;
      select.value = option.value;
      select.dispatchEvent(new Event('input', { bubbles: true }));
      select.dispatchEvent(new Event('change', { bubbles: true }));
      await new Promise((resolve) => window.setTimeout(resolve, 50));
      placeholder.querySelector('.buunto-order-selection-save')?.click();
    } catch (error) {
      console.warn('Buunto background sync could not complete.', error);
    }
  };

  document.addEventListener('FlorariaIrinuca:deliverySelection', (event) => {
    syncNativeSelectionToBuunto(event.detail || {});
  });

  document.addEventListener('BuuntoDatePicker:selectionChange', (event) => applySelection(event.detail || {}));
  document.addEventListener('BuuntoDatePicker:cartAttributesUpdated', (event) => {
    applySelection(event.detail || {});
    step.dataset.buuntoSaved = 'true';
  });
})();


/* Smart full-search fallback: mirrors predictive search when Shopify's full search is too strict. */
(() => {
  const section = document.querySelector('[data-smart-search-page]');
  if (!section || section.dataset.serverResults !== '0') return;
  const query = (section.dataset.searchQuery || '').trim();
  const grid = section.querySelector('[data-smart-search-grid]');
  const empty = section.querySelector('[data-search-empty]');
  if (query.length < 2 || !grid) return;

  const aliases = {
    trand: 'trandafiri', trandafir: 'trandafiri', trandaf: 'trandafiri',
    buchet: 'buchete', buche: 'buchete', hort: 'hortensie',
    bujor: 'bujori', crin: 'crini', cadou: 'cadouri', planta: 'plante'
  };
  const clean = query.toLocaleLowerCase('ro-RO').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  const key = Object.keys(aliases).find((item) => clean === item || clean.startsWith(item));
  const expanded = key ? aliases[key] : query;
  const base = window.Shopify?.routes?.root || '/';

  const money = (value) => new Intl.NumberFormat('ro-RO', {
    style: 'currency', currency: 'RON', maximumFractionDigits: 0
  }).format(Number(value || 0));

  fetch(base + 'search/suggest.json?q=' + encodeURIComponent(expanded) + '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last')
    .then((response) => response.ok ? response.json() : Promise.reject())
    .then((data) => {
      const products = data?.resources?.results?.products || [];
      if (!products.length) return;
      grid.replaceChildren();
      products.forEach((product) => {
        const card = document.createElement('article');
        card.className = 'product-card';
        card.innerHTML =
          '<a class="product-card__media" href="' + product.url + '" aria-label="Vezi produsul ' + product.title.replace(/"/g, '&quot;') + '">' +
            (product.image ? '<img src="' + product.image + '" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
          '</a>' +
          '<div class="product-card__info">' +
            '<h3 class="product-card__title"><a href="' + product.url + '"></a></h3>' +
            '<div class="product-card__price"></div>' +
            '<div class="product-card__micro"><span class="stars">★★★★★</span></div>' +
            '<a class="product-card__cta" href="' + product.url + '"><span>Trimite flori</span><span>→</span></a>' +
          '</div>';
        card.querySelector('.product-card__title a').textContent = product.title;
        card.querySelector('.product-card__price').textContent = money(product.price);
        grid.append(card);
      });
      empty?.setAttribute('hidden', '');
      grid.hidden = false;
      const summary = section.querySelector('.search-page__summary p');
      if (summary) summary.textContent = products.length + (products.length === 1 ? ' produs găsit' : ' produse găsite');
    })
    .catch(() => {});
})();


/* Florăria Irinuca: same-day delivery estimate */
(() => {
  const renderEarliestDelivery = () => {
    const targets = document.querySelectorAll('[data-earliest-delivery]');
    if (!targets.length || !window.Intl) return;

    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Bucharest',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    }).formatToParts(new Date());
    const hour = Number(parts.find((part) => part.type === 'hour')?.value || 0);
    const minute = Number(parts.find((part) => part.type === 'minute')?.value || 0);
    const currentHour = hour + minute / 60;
    let label;

    if (currentHour >= 20) {
      label = 'Mâine · 11:00–12:00';
    } else {
      const start = Math.min(21, Math.max(11, Math.ceil(currentHour + 1.5)));
      label = 'Astăzi · ' + String(start).padStart(2, '0') + ':00–' + String(start + 1).padStart(2, '0') + ':00';
    }

    targets.forEach((target) => {
      target.textContent = label;
    });
  };

  document.addEventListener('DOMContentLoaded', renderEarliestDelivery);
  setInterval(renderEarliestDelivery, 60000);
})();
